import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { AssignmentsView } from '@/modules/lessonDetails'
import { courseQueryOptions } from '@/queries/useCourse'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/timetable/$courseId/$groupId/assignments'
)({
  validateSearch: z.object({
    open: z.string().optional()
  }),
  component: AssignmentsView,
  loader: async ({ context, params: { courseId } }) => {
    const course = await context.queryClient.ensureQueryData(
      courseQueryOptions(courseId)
    )
    return course.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.assignments', { ns: 'lessonDetails' })
    ])
})
